module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/flow-consul-d7336b2c84f749b876f5c87dd6f74320.png";